import { toggleBlockType } from 'tiptap-commands';
import { Node } from 'tiptap';
import { toggleMark, updateMark } from 'tiptap-commands'
import { Mark } from 'tiptap'

export default class AlignPara extends Mark {

    get name() {
        return "alignpara";

    }

    get defaultOptions() {
        return {
            textAlign: ['left', 'center', 'right'],
        }
    }

    get schema() {
        return {
            attrs: {
                textAlign: {
                    default: 'left',
                }
            },
            parseDOM: [
                {
                    style: 'text-align',
                    getAttrs: value => value
                }
            ],

            toDOM: mark => {
                return ['span', { style: `text-align: ${mark.attrs.textAlign};display: block` }, 0]
            }
        }
    }
    commands({ type }) {
        return attrs => {
            return updateMark(type, attrs)
        }
    }
}